import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "up",
  "use": "up-usage",
  "viewBox": "0 0 9 4",
  "content": "<symbol viewBox=\"0 0 9 4\" id=\"up\"><path fill-rule=\"evenodd\" d=\"M4.5 0L9 4H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/caret/up.svg
// module id = ./src/assets/icons/caret/up.svg
// module chunks = 4